/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { useState } from 'react';

import { configuredClustersStore } from 'stores';

import CreationModal from './CreationModal.common';
import { DevelopmentClusterSelection } from './development-cluster-selection';

export default () => {
  const [developmentCluster, setDevelopmentCluster] = useState(configuredClustersStore.clusters?.[0]);

  return (
    <CreationModal
      modalContentExtensionSection={
        <DevelopmentClusterSelection
          developmentCluster={developmentCluster}
          setDevelopmentCluster={setDevelopmentCluster}
        />
      }
      getAdditionalParametersWhenFinalizingCreation={() => [developmentCluster?.id]}
    />
  );
};
